/**
 * 文件定位：
 * 1. 当前文件位于 cad-core/feature/projection 层；
 * 2. 负责统一解析设计树节点的特征编辑能力；
 * 3. 该策略收口所有“某类特征是否支持编辑特征/编辑草图”的公开语义，避免 web-client 本地硬编码。
 *
 * 文件职责：
 * 1. 根据特征种类输出设计树可用编辑能力；
 * 2. 保持编辑能力决策集中在 cad-core 单一真相中心；
 * 3. 为后续新增特征扩展编辑能力时提供统一入口。
 */

/**
 * 特征节点编辑能力。
 */
export interface FeatureNodeEditCapabilities {
    /** 是否支持编辑特征参数。 */
    canEditFeature: boolean;
    /** 是否支持编辑源草图。 */
    canEditSketch: boolean;
}

/**
 * 特征节点编辑能力策略。
 */
export class FeatureNodeEditPolicy {
    /**
     * 解析指定特征种类的设计树编辑能力。
     *
     * @param featureKind 特征种类。
     * @returns 对应编辑能力。
     */
    public resolve(featureKind: string | null | undefined): FeatureNodeEditCapabilities {
        switch (featureKind) {
            case 'boss-extrude':
            case 'cut-extrude':
                return {
                    canEditFeature: true,
                    canEditSketch: true,
                };
            case 'chamfer':
            case 'fillet':
                return {
                    canEditFeature: true,
                    canEditSketch: false,
                };
            case 'boss-revolve':
            case 'cut-revolve':
                return {
                    canEditFeature: true,
                    canEditSketch: true,
                };
            default:
                return {
                    canEditFeature: false,
                    canEditSketch: false,
                };
        }
    }
}

/**
 * 默认特征节点编辑能力策略实例。
 */
export const featureNodeEditPolicy = new FeatureNodeEditPolicy();
